import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "entity-header" }
const _hoisted_2 = { class: "item-content" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "text-content" }
const _hoisted_6 = { class: "description" }
const _hoisted_7 = {
  key: 0,
  class: "entity-description"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.IsIconUrlValid())
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.imageUrl,
            alt: "avatar",
            class: "icon-Img round-image icon-img-custom",
            style: _normalizeStyle({ width: _ctx.size + 'px', height: _ctx.size + 'px' })
          }, null, 12, _hoisted_3))
        : (_ctx.HasName())
          ? (_openBlock(), _createBlock(_component_Avatar, {
              key: 1,
              background: _ctx.GetDefaultBackgroundColor(),
              color: _ctx.GetDefaultForegroundColor(),
              size: _ctx.size,
              lighten: 40,
              border: false,
              name: _ctx.GetIntials(_ctx.firstName, _ctx.lastName),
              class: "display-contents"
            }, null, 8, ["background", "color", "size", "name"]))
          : (_openBlock(), _createElementBlock("img", {
              key: 2,
              src: _ctx.defaultIcon,
              class: "icon-Img round-image icon-img-default",
              style: _normalizeStyle({ width: _ctx.size + 'px', height: _ctx.size + 'px' })
            }, null, 12, _hoisted_4)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.title), 1),
        (_ctx.description)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.description), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}